import { Component } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { ToastrService } from 'ngx-toastr';
import { CommonService } from 'src/app/services/common.service';
import { UserService } from 'src/app/services/user.service';
import { WalletService } from 'src/app/services/wallet.service';

@Component({
  selector: 'app-commision-transaction',
  templateUrl: './commision-transaction.component.html',
  styleUrls: ['./commision-transaction.component.css']
})
export class CommisionTransactionComponent {


  transactions: any = []
  tranxdetails: any = []
  search: any = '';
  constructor(private commonService:CommonService ,  private cookieService: CookieService, private userService:UserService,private walletService:WalletService, private toastr: ToastrService){

  }

  token:any
  loader = false;

  ngOnInit(){

    this.token = this.cookieService.get('user_token');
   

    this.userService.getUserApi().subscribe({
      next:(v:any)=>{
        if (v.success) {
          console.log("this is quekks");
          this.commonService.getcommisiondata(v.result._id , this.token)
          .subscribe({
            next: (v: any) => {
              if (v.status) {
                this.transactions = v.data.docs
                this.loader = true
                console.log("this is quekks" ,  this.transactions);
                
              }
            },
            error: (err) => {
              // console.log(err)
            }
          })
        }
      },
      error: (err) => {
        console.log(err)
      }
    })
   
    this.getUserEarnTrack()
    
  }

  getUserEarnTrack(){
    this.commonService.getUSerHoldingTrack(this.token)
          .subscribe({
            next: (v: any) => {
              
              this.tranxdetails = v.result
              console.log("the okay kyc" , this.tranxdetails );
                this.loader = true
                
              
            },
            error: (err) => {
              // console.log(err)
            }
          })
        
      }
    
  

  sendWithdrawRequest(id: string) {
    const reqData = {
      depositId: id
    }
    if (confirm('Are you sure you want to withdraw staked coins?')) {
      this.walletService.withdrawRequestStakedCoins(reqData).subscribe({
        next: (v: any) => {
          this.toastr.success(v.message)
        },
        error: (err) => { },
      });
    }

  }


  handleSearch(event: any) {
    this.search = event.target.value.toUpperCase().replace('/', '')
  }

}
